import type { ComponentPropsWithoutRef } from 'react'

const ControlGroup = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => (
  <div className={`mt-2.5 bg-[#f5f5f5] p-4 ${className}`} {...props} />
)

export default ControlGroup
